module.exports = __webpack_public_path__ + "images/benelli_small142b95f59ecbb01522ec7afde3a8180a.png";